var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"bar","width":"100%","height":"270","options":_vm.chartOptions,"series":[
      {
        name: 'Importe',
        data: [_vm.data.cashSum || 0, _vm.data.creditCardSum || 0, _vm.data.bankSum || 0],
      },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }